import { render, staticRenderFns } from "./PcComponent.vue?vue&type=template&id=0fd036cf&"
import script from "./PcComponent.vue?vue&type=script&lang=js&"
export * from "./PcComponent.vue?vue&type=script&lang=js&"
import style0 from "./PcComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports